"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var http_h5_1 = require("@uip-alpha/http-h5");
var storage_h5_1 = require("@uip-alpha/storage-h5");
exports.default = {
    name: 'base-h5',
    install: function (UIP) {
        UIP.use(http_h5_1.default);
        UIP.use(storage_h5_1.default);
    }
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@uip-alpha/base-h5/dist/index.js
// module id = YS0n
// module chunks = 1